<template>
  <v-main class="main-container">
    <MyInvitations />
  </v-main>
</template>

<script>
import MyInvitations from "@/components/templates/MyInvitations";

export default {
  components: { MyInvitations },
};
</script>
